"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updatePayerMasterSchema = exports.createPayerMasterSchema = exports.payerMasterShape = exports.payerTypeEnum = void 0;
const zod_1 = require("zod");
exports.payerTypeEnum = zod_1.z.enum([
    'SELF_PAY',
    'INSURANCE',
    'TPA',
    'CORPORATE',
    'GOVERNMENT_SCHEME',
]);
exports.payerMasterShape = {
    payerCode: zod_1.z.string().min(1).max(30),
    name: zod_1.z.string().min(1).max(255),
    payerType: exports.payerTypeEnum,
    contactEmail: zod_1.z.string().email().optional(),
    contactPhone: zod_1.z.string().max(20).optional(),
    creditLimit: zod_1.z.number().nonnegative().optional(),
};
exports.createPayerMasterSchema = zod_1.z.object(exports.payerMasterShape);
exports.updatePayerMasterSchema = zod_1.z.object({
    name: exports.payerMasterShape.name.optional(),
    payerType: exports.payerTypeEnum.optional(),
    contactEmail: exports.payerMasterShape.contactEmail,
    contactPhone: exports.payerMasterShape.contactPhone,
    creditLimit: exports.payerMasterShape.creditLimit,
});
//# sourceMappingURL=payer-master.schema.js.map